// TODO: Make this function able to map ambiguous parameters to
// properties needed for ReturnItem component.

// TODO: Move all hardcoded values to JSON.
export default (
  { itemDescription, itemQuantity, itemComment, selectedReason, returnDescription, extendItems = {} },
  language,
) => ({
  itemDescription,
  itemQuantity,
  itemComment,
  returnDescription,
  blindItem: true,
  item_desc: itemDescription,
  item_name: itemDescription,
  itemQty: itemQuantity,
  item_qty: itemQuantity,
  item_price: 0, // This is a required field for /returninfo, sending this as 0 so POST doesn't fail
  remaining_qty: itemQuantity,
  return_qty: itemQuantity,
  returned: true,
  return_reason_code_id: selectedReason && selectedReason.return_reason_code_id,
  return_desc: selectedReason && selectedReason.reason_category,
  itemStatus: `${language['returns.item.reason_label'] || 'Return Reason:'} ${returnDescription}`,
  selected: true,
  selectedReason,
  total_price: 0,
  user_comment: itemComment,
  ...extendItems,
});
